import { axiosThirdparty } from "./axios";

export const Feedback = async (requestData:any): Promise<any> => {
    return axiosThirdparty.post('/contactUs', requestData);
  }